import { Button, Dialog, DialogContentText, DialogTitle } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import CloseIcon from '@material-ui/icons/Close'
import PrintIcon from '@material-ui/icons/Print'
import React, { FC, useEffect, useRef } from 'react'
import { useReactToPrint } from 'react-to-print'

import * as Styled from './styled'

export interface TestKitLegalTermsModalProps {
  isOpen: boolean
  closeModal: () => void
}

export const TestKitLegalTermsModal: FC<TestKitLegalTermsModalProps> = ({ isOpen, closeModal }) => {
  const descriptionElementRef = useRef<HTMLDivElement | null>(null)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

  useEffect(() => {
    if (isOpen) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
  }, [isOpen])

  const handlePrint = useReactToPrint({
    content: () => descriptionElementRef.current,
  })

  return (
    <Dialog
      aria-describedby="scroll-dialog-description"
      aria-labelledby="scroll-dialog-title"
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      onClose={closeModal}
      open={isOpen}
      scroll="paper"
      style={{ zIndex: 11_000 }}
    >
      <Styled.CustomDialogContent>
        <DialogContentText
          component="section"
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        >
          <DialogTitle id="scroll-dialog-title">Ordering Clinician Policy</DialogTitle>
          <Styled.TextContainer>
            This Ordering Clinician Policy is an agreement (&quot;Agreement&quot;) between me and
            Designs for Health, Inc. (&quot;DFH&quot;) regarding each
            <b> GI Spotlight&trade;, Genomic Spotlight&trade;, Metabolomics Spotlights&trade;</b>,
            or other functional wellness test analysis program that is offered for sale now or in
            the future by DFH program (&quot;Program&quot;) and purchased, added to an eScript, or
            otherwise made available (collectively, &quot;Provided&quot;) for use by any person
            other than me (each a &quot;Customer&quot;). To the extent required by applicable law:
            <ol style={{ listStyle: 'upper-roman' }}>
              <li>
                I will not Provide any Program to a Customer unless the Customer gives informed
                consent and receives sufficient notice regarding the collection, use, retention, or
                disclosure of the Customer’s test results or other personal information;
              </li>
              <li>
                I will satisfy any legally binding requests by the Customer to access, correct, or
                otherwise act on the Customer&apos;s personal information associated with the
                Program, seeking DFH&apos;s assistance if necessary; and
              </li>
              <li>
                DFH may, but is not required to, respond directly to any such requests it receives,
                in which case it will attempt to notify me.
              </li>
            </ol>
            If any person or business employs me or otherwise uses my services in the process of
            Providing Programs to Customers (my &quot;Employer&quot;), then I accept this Agreement
            also on my Employer&apos;s behalf and warrant I am legally authorized to do so.
          </Styled.TextContainer>
        </DialogContentText>
      </Styled.CustomDialogContent>
      <Styled.CustomDialogActions>
        <Button onClick={handlePrint} color="primary">
          <PrintIcon />
        </Button>
        <Button onClick={closeModal} color="primary">
          <CloseIcon />
        </Button>
      </Styled.CustomDialogActions>
    </Dialog>
  )
}
